import { render } from "./ProfileCriticalEvents.vue?vue&type=template&id=20d3e045"
import script from "./ProfileCriticalEvents.vue?vue&type=script&lang=js"
export * from "./ProfileCriticalEvents.vue?vue&type=script&lang=js"

import "./ProfileCriticalEvents.vue?vue&type=style&index=0&id=20d3e045&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__